import { Injectable } from '@angular/core';
import {StorageCollections } from '../enum/storage-collections.enum';
import * as _ from 'lodash';
import { NgxIndexedDB } from './ngx-index-db';

@Injectable()
export class Storage {
  private db: NgxIndexedDB;
  private dbPromise: Promise<any>;
  private databaseName = 'hubconnect_db';
  constructor() {
    this.db = new NgxIndexedDB(this.databaseName, 1);
    this.dbPromise = this.intializeStorage();
  }

  private intializeStorage() {
    return this.db.openDatabase(1, evt => {
      this.createDefaultObjectStores(evt, [
        StorageCollections.SECURITY,
        StorageCollections.CONFIG,
        StorageCollections.HUBCONNECT
      ]);
    });
  }
  private createDefaultObjectStores(db: any, collectionNames: string[]) {
    collectionNames.forEach((collectionName: string) => {
      const objectStore = db.currentTarget.result.createObjectStore(
        collectionName,
        { keyPath: 'name' }
      );
      objectStore.createIndex('name', 'name', { unique: true });
      console.log('===> storage created <===');
    });
  }

  createObjectStore(collectionName: string, indexes: [] = [], key: any = null) {
    return this.db.openDatabase(1, evt => {
      const objectStore = evt.currentTarget.result.createObjectStore(
        collectionName,
        key
      );
      indexes.map(index => {
        objectStore.createIndex(index, index, { unique: false });
      });
    });
  }

  public async getItem(item: string, collection: string = StorageCollections.SECURITY) {
    await this.dbPromise;
    return this.db.getByIndex(collection, 'name', item).then(
      result => {
        return _.get(result, 'value', '');
      },
      error => {
        console.log(error);
      }
    );
  }

  public async setItem(
    key: string = 'name',
    value: any,
    collection: string = StorageCollections.SECURITY
  ) {
    await this.dbPromise;
    return this.db.update(collection, { name: key, value }).then(
      () => {
        return;
      },
      error => {
        console.log(error);
      }
    );
  }
  public async removeObjectStore(collection: string) {
    await this.dbPromise;
    this.db.clear(collection).then(
      () => {
        console.log('Storage cleared ', collection);
      },
      error => {
        console.log(error);
      }
    );
  }
  public async removeItem(collection: string, id: string) {
    await this.dbPromise;
    this.db.delete(collection, id).then(
      () => {
        console.log('item removed ', collection, id);
      },
      error => {
        console.log(error);
      }
    );
  }

  public async truncateDB() {
    await this.dbPromise;
    return await this.db.deleteDatabase();
  }
}
